const levels = {
	h1: 'h1',
	h2: 'h2',
	h3: 'h3',
	h4: 'h4',
	h5: 'h5',
	h6: 'h6',
};

export default function Heading(props) {
	const TagName = levels[props.level || 'h1'];
	return (
		<TagName {...props}>
			{props.title || props.children}
		</TagName>
	)
}
